















import SimpleInput from '@/UI/Shared/SimpleInput.vue'
import FieldModel from '@/UI/Shared/Mixins/FieldModel'
import mixins from 'vue-typed-mixins'
import { AccountId } from '@/Domain/Account'

export default mixins(FieldModel).extend({
  name: 'SurnameByNifInput',
  components: { SimpleInput },
  props: {
    label: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      required: true
    },
    nif: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      isValid: true
    }
  },
  computed: {
    accountId (): AccountId | null {
      if (this.nif === '') {
        return null
      }
      try {
        const accountId = new AccountId(this.nif)
        return accountId
      } catch {
        return null
      }
    },
    isCompany (): boolean {
      return this.accountId !== null && this.accountId.isCompany()
    },
    requiredStatus (): string {
      if (this.isCompany === false) {
        return 'required'
      }
      return ''
    },
    inputStatus (): string {
      if (this.isCompany === true && this.currentValue === '') {
        return ''
      }
      return this.isValid
        ? 'success'
        : 'danger'
    },
    errorMessage (): string {
      return this.inputStatus === 'danger'
        ? this.$t('subasta.persoais.surname-required-if-nif').toString()
        : ''
    }
  },
  watch: {
    nif (): void {
      this.validateInput()
    }
  },
  methods: {
    validateInput (): void {
      if (this.isCompany === false) {
        this.isValid = this.currentValue !== ''
        this.$emit('input', this.currentValue)
        return
      }
      this.isValid = true
      this.$emit('input', this.currentValue)
    }
  }
})
